/* Setas do carrossel da secao "Categorias em foto".
   Delegacao no document: sobrevive a re-renderizacao da secao pelo tema/editor. */
(function () {
  if (window.__cfCatNav) return;
  window.__cfCatNav = true;

  function gridOf(root) {
    return root ? root.querySelector('.cf-cat__grid') : null;
  }

  function padStart(g) {
    return parseFloat(getComputedStyle(g).paddingInlineStart) || 0;
  }

  function step(g) {
    var item = g.querySelector('.cf-cat__item');
    if (!item) return g.clientWidth * 0.7;
    var gap = parseFloat(getComputedStyle(g).columnGap) || 0;
    var w = item.getBoundingClientRect().width + gap;
    return Math.max(w, g.clientWidth - w);
  }

  function sync(root) {
    var g = gridOf(root);
    if (!g) return;
    var media = g.querySelector('.cf-cat__media');
    if (media && media.offsetHeight) {
      root.style.setProperty('--cf-arrow-top', (media.offsetTop + media.offsetHeight / 2) + 'px');
    }
    var prev = root.querySelector('.cf-cat__nav--prev');
    var next = root.querySelector('.cf-cat__nav--next');
    if (!prev || !next) return;
    /* o scroll-snap alinha o 1o item depois do padding, entao em repouso
       scrollLeft == padding-inline-start e nao zero */
    var rest = padStart(g) + 4;
    var max = g.scrollWidth - g.clientWidth;
    var can = max > rest;
    prev.classList.toggle('is-off', !can || g.scrollLeft <= rest);
    next.classList.toggle('is-off', !can || g.scrollLeft >= max - 4);
  }

  function syncAll() {
    var list = document.querySelectorAll('.cf-cat');
    for (var i = 0; i < list.length; i++) sync(list[i]);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.cf-cat__nav');
    if (!btn) return;
    var root = btn.closest('.cf-cat');
    var g = gridOf(root);
    if (!g) return;
    var dir = btn.classList.contains('cf-cat__nav--prev') ? -1 : 1;
    g.scrollBy({ left: dir * step(g), behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var g = e.target;
    if (g && g.classList && g.classList.contains('cf-cat__grid')) {
      sync(g.closest('.cf-cat'));
    }
  }, true);

  window.addEventListener('resize', syncAll);
  window.addEventListener('load', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();
  requestAnimationFrame(syncAll);
  setTimeout(syncAll, 400);
})();
